var map = {
	"./img_logo_1.png": "3c26",
	"./img_logo_10.png": "c306",
	"./img_logo_11.png": "8ad7",
	"./img_logo_12.png": "fc21",
	"./img_logo_13.png": "9c40",
	"./img_logo_2.png": "a1b4",
	"./img_logo_3.png": "a260",
	"./img_logo_4.png": "908a",
	"./img_logo_5.png": "4d0f",
	"./img_logo_6.png": "b4d6",
	"./img_logo_7.png": "584f",
	"./img_logo_8.png": "06f0",
	"./img_logo_9.png": "9cec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8125";